import { ClickEventOptions, MessageCenterClickEventOptions, sendTealiumClickEvent, sendTealiumMessageCenterClickEvent } from './sendTealiumEvent'
import events, { Event, Subscriber } from 'pubsub/events'

let subscription: Subscriber

export const startListening = () => {
  subscription = events.subscribe({
    next: (event: Event) => {
      const shouldSendToTealium = event.sendToTealium

      if (shouldSendToTealium) {
        const tealiumEvent: ClickEventOptions = {
          logged_in: event.authenticated,
          text: event.text,
          category: event.category,
          target_location: event.targetLocation,
          subheading: event.subheading,
          heading: event.heading
        }
        if (event.isMessageCenter && event.eventName !== undefined && event.messageStatus !== undefined && event.messageSubject !== undefined && event.messageComponent !== undefined) {
          // do this based on type?
          const messageCenterTealiumEvent: MessageCenterClickEventOptions = {
            logged_in: event.authenticated,
            text: event.text,
            category: event.category,
            element: event.element,
            message_status: event.messageStatus,
            message_subject: event.messageSubject,
            event_name: event.eventName,
            message_component: event.messageComponent
          }
          sendTealiumMessageCenterClickEvent(messageCenterTealiumEvent)
        } else {
          sendTealiumClickEvent(tealiumEvent)
        }
      }
    },
    error: (error) => {
      console.log('error:', error)
    },
    complete: () => {
      console.log('complete')
    }
  })
}

const unsubscribe = () => {
  subscription.unsubscribe()
}

const trackWithTealium = {
  startListening,
  unsubscribe
}

export default trackWithTealium
